export const STEPS = {
  EVENT_DETAILS: 1,
  ROLE: 2,
  DETAILS: 4,
  CATEGORIES: 3,
  CATEGORY_DETAILS: 4,
  TIMELINE: 5,
  BUDGET: 6
};

export const STEP_LABELS = [
  "Event Details",
  "Role",
  "Categories", 
  "Details",
  "Timeline",
  "Budget"
];

export const ROLES = [
  'Event Planner',
  'Producer',
  'Director',
  'Client',
  'Venue Manager',
  'Caterer',
  'Technical Director',
  'Marketing Manager'
];

export const BUDGET_CATEGORIES = [
  'Venue & Space',
  'Talent & Entertainment',
  'Production & Technical',
  'Food & Beverage',
  'Marketing & Promotion',
  'Staffing & Personnel',
  'Transportation & Logistics',
  'Accommodations',
  'Insurance & Permits',
  'Miscellaneous & Contingency'
];

export const EVENT_TYPES = [
  { value: '', label: 'Select event type' },
  { value: 'conference', label: 'Conference/Convention' },
  { value: 'music', label: 'Music Festival/Concert' },
  { value: 'corporate', label: 'Corporate Event' },
  { value: 'wedding', label: 'Wedding' },
  { value: 'film', label: 'Film Production' },
  { value: 'theater', label: 'Theater Production' },
  { value: 'tradeshow', label: 'Trade Show' },
  { value: 'award', label: 'Award Ceremony' },
  { value: 'other', label: 'Other' }
];

export const EVENT_SCALES = [
  { value: '', label: 'Select scale' },
  { value: 'small', label: 'Small (less than 100 attendees)' },
  { value: 'medium', label: 'Medium (100-500)' },
  { value: 'large', label: 'Large (500-2000)' },
  { value: 'verylarge', label: 'Very Large (2000+)' }
];

export const LOCATION_TYPES = [
  { value: '', label: 'Select location type' },
  { value: 'urban', label: 'Urban' },
  { value: 'suburban', label: 'Suburban' },
  { value: 'rural', label: 'Rural' },
  { value: 'destination', label: 'Destination' }
];

export const INITIAL_FORM_STATE = {
  eventName: '',
  eventType: '',
  eventScale: '',
  duration: '',
  locationType: '',
  totalBudget: '',
  primaryRole: '',
  categories: [],
  categoryPriorities: {},
  budgetBreakdown: null
}; 